import { useOverlayScale } from "../editor/hooks";
import { cn } from "@acdc2/ui/lib/utils";
import { Moveable } from "../ui/Moveable";

type Props = {
  cx: number;
  cy: number;
  onMove: (movementX: number, movementY: number) => void;
  onDone: () => void;
  onDelete: () => void;
};

export function RegionReshapeHandle({
  cx,
  cy,
  onMove,
  onDone,
  onDelete,
}: Props) {
  const overlayScale = useOverlayScale();

  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Delete" || event.key === "Backspace") {
      event.stopPropagation();
      onDelete();
    }
  };

  return (
    <Moveable onMove={onMove} onDone={onDone}>
      <circle
        cx={cx}
        cy={cy}
        r={6 / overlayScale}
        strokeWidth={4 / overlayScale}
        className={cn(
          "pointer-events-auto cursor-move fill-white stroke-brand focus:fill-brand focus:outline-hidden",
        )}
        vectorEffect="non-scaling-stroke"
        onClick={onClick}
        onKeyDown={onKeyDown}
        tabIndex={0} // Enable receiving keyboard events
      />
    </Moveable>
  );
}
